import {whitelabelling as Whitelabelling} from 'whitelabelling';

export function userInputPrimaryRole() {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            hideBoth: '=?',
        },
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/directives/userInputs/userInputPrimaryRole.html',
        controller: [
            '$scope', function($scope) {
                $scope.whitelabelling = Whitelabelling;
                $scope.customRegistrationBoth = Whitelabelling.settings['customized:registrationBoth'] || 'Both!';
            },
        ],
    };
}
